/*
 * diamond-similar.js
 * Fetches Shopify's native product recommendations (related intent) and renders
 * compact diamond cards into [data-similar-row]. Critical for the sold-out state:
 * it redirects a visit from a dead stone to live ones, recovering the visit and
 * keeping the page useful.
 */
(function () {
  'use strict';
  // Match both the classic (.dpage) and the elevated (.dpro) product templates.
  var root = document.querySelector('.dpage__similar, .dpro__similar');
  if (!root) return;
  var row = root.querySelector('[data-similar-row]');
  var productId = root.dataset.productId;
  var base = root.dataset.recommendationsUrl || '/recommendations/products';
  if (!productId) return;

  var url = base + (base.indexOf('?') > -1 ? '&' : '?') +
    'product_id=' + encodeURIComponent(productId) +
    '&limit=8&intent=related';

  fetch(url, { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var products = (data && data.products) || [];
      if (!products.length) { root.style.display = 'none'; return; }
      row.innerHTML = '';
      products.forEach(function (p) {
        var a = document.createElement('a');
        a.className = 'dsim-card';
        a.href = p.url;
        var img = p.featured_image || (p.images && p.images[0]) || '';
        a.innerHTML =
          '<div class="dsim-card__img">' + (img ? '<img loading="lazy" src="' + img + '" alt="' + (p.title || '') + '">' : '') + '</div>' +
          '<div class="dsim-card__title">' + (p.title || '') + '</div>' +
          '<div class="dsim-card__price">' + formatMoney(p.price) + '</div>';
        row.appendChild(a);
      });
    })
    .catch(function () { root.style.display = 'none'; });

  // Shopify returns price in cents (integer). Format minimally; theme money
  // format isn't available in JS, so we render the store currency symbol-less
  // amount with a thin space — good enough for a related row.
  function formatMoney(cents) {
    if (typeof cents !== 'number') return '';
    var v = (cents / 100).toLocaleString(undefined, { maximumFractionDigits: 0 });
    return v + ' ' + (window.Shopify && Shopify.currency ? Shopify.currency.active : '');
  }
})();
